import { getRelatedDramas } from "@/lib/data";
import type { Drama } from "@/types";
import DramaCard from "@/components/base/DramaCard";

export default function RelatedDramas({ drama }: { drama: Drama }) {
  const related = getRelatedDramas(drama, 4);
  if (related.length === 0) return null;

  return (
    <section>
      <div className="flex items-center gap-3 mb-5">
        <span className="w-1.5 h-6 rounded-full bg-primary-500" />
        <h2 className="font-heading text-xl font-bold text-foreground-950">
          相关推荐
        </h2>
        <span className="text-xs text-foreground-400 ml-auto">基于类型与标签推荐</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
        {related.map((d) => (
          <DramaCard key={d.id} drama={d} />
        ))}
      </div>
    </section>
  );
}